const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="py-24 px-6 border-b border-stone-800/80 max-w-7xl mx-auto"
    >
      <div className="grid lg:grid-cols-3 gap-12 items-start">
        <div className="space-y-4">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">
            Mission Mandate
          </span>
          <h2 className="text-3xl font-bold tracking-tight text-stone-100 display-serif">
            Autonomous Ecosystem
          </h2>
          <p className="text-stone-400 text-sm leading-relaxed">
            The Bourganization Institute exists to eradicate systemic dependencies. We provide
            individuals and enterprises with the structural blueprints needed to run independently.
          </p>
        </div>
        <div className="lg:col-span-2 grid sm:grid-cols-2 gap-6">
          <div className="p-6 rounded-xl bg-stone-900/60 border border-stone-800 space-y-3">
            <h3 className="text-lg font-semibold text-stone-200">Non-Profit Business League</h3>
            <p className="text-xs text-stone-400 leading-relaxed">
              Organized as a 501(c)(6) non-profit tax haven BGNZN. We do not sell retail services;
              we facilitate sovereign knowledge, barter protocols, and mutual community enrichment.
            </p>
          </div>
          <div className="p-6 rounded-xl bg-stone-900/60 border border-stone-800 space-y-3">
            <h3 className="text-lg font-semibold text-stone-200">Daily Intensive Mentorship</h3>
            <p className="text-xs text-stone-400 leading-relaxed">
              Our leadership dedicates an average of over six hours daily to educating participants,
              customizing hours to the exact operational rhythms of the members we serve.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
